import React from 'react';
import { isAndroid } from 'react-device-detect';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

import theme from '../../styles/theme';
import GlobalStyle from '../../styles/GlobalStyles';

const StyleProviderView: React.FC = ({ children }) => {
    const os = isAndroid ? 'android' : 'ios';
    return (
        <MuiThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
                <GlobalStyle os={os} />
                {children}
            </ThemeProvider>
        </MuiThemeProvider>
    );
};

export default StyleProviderView;
